export default __webpack_public_path__ + "static/media/master.24bdbeb4.svg";